/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminUavTeamActivation
 */
export interface InputAdminUavTeamActivation {
    /**
     * 
     * @type {boolean}
     * @memberof InputAdminUavTeamActivation
     */
    active?: boolean;
}

/**
 * Check if a given object implements the InputAdminUavTeamActivation interface.
 */
export function instanceOfInputAdminUavTeamActivation(value: object): boolean {
    return true;
}

export function InputAdminUavTeamActivationFromJSON(json: any): InputAdminUavTeamActivation {
    return InputAdminUavTeamActivationFromJSONTyped(json, false);
}

export function InputAdminUavTeamActivationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminUavTeamActivation {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function InputAdminUavTeamActivationToJSON(value?: InputAdminUavTeamActivation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'active': value['active'],
    };
}

